import type { PlcManufacturerCodeLibrary } from "./types";

export const beckhoffCodeLibrary: PlcManufacturerCodeLibrary = {
  manufacturer_id: "beckhoff",
  manufacturer_name: "Beckhoff",
  codes: [
    {
      id: "beckhoff-tcdmx-8001",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: null,
      code: "0x8001",
      code_type: "TwinCAT PLC Library",
      title_ar: "ماكو جواب من DMX Terminal",
      description_ar: "مكتبة Beckhoff TcDMX رجعت 0x8001 لأن DMX terminal ما رد.",
      symptoms: ["Function block يرجع Error", "ماكو اتصال ويا DMX terminal"],
      causes: ["Terminal مو متصل أو مو جاهز", "إعداد/منفذ الاتصال مو صحيح"],
      checks: [
        {
          step: 1,
          action: "راجع terminal والـport والإعدادات بالـTwinCAT.",
          expected: "الـterminal يرد والـFB يرجع بدون خطأ.",
          faulty: "يبقى 0x8001.",
        }
      ],
      solutions: ["افحص التوصيل والطاقة للـterminal.", "راجع إعدادات المكتبة والـport."],
      severity: "عالية",
      source_title: "Beckhoff TwinCAT 2 PLC Library TcDMX",
      source_section: "Error codes: 0x8001 No answer from the DMX terminal",
      keywords: ["Beckhoff", "TwinCAT", "TcDMX", "0x8001"],
    },
    {
      id: "beckhoff-tcdmx-8002",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: null,
      code: "0x8002",
      code_type: "TwinCAT PLC Library",
      title_ar: "ماكو جواب من DMX Device",
      description_ar: "مكتبة TcDMX رجعت 0x8002 لأن جهاز DMX نفسه ما رد.",
      symptoms: ["DMX device offline", "Function block يرجع 0x8002"],
      causes: ["الجهاز غير متصل", "العنوان أو المسار مو صحيح", "الجهاز بدون تغذية"],
      checks: [
        {
          step: 1,
          action: "افحص الجهاز وعنوانه والمسار.",
          expected: "الجهاز يرد.",
          faulty: "يبقى بدون جواب.",
        }
      ],
      solutions: ["صحح التوصيل والعنوان.", "افحص تغذية جهاز DMX."],
      severity: "عالية",
      source_title: "Beckhoff TwinCAT 2 PLC Library TcDMX",
      source_section: "Error codes: 0x8002 No answer from the DMX device",
      keywords: ["Beckhoff", "TwinCAT", "TcDMX", "0x8002"],
    },
    {
      id: "beckhoff-tcdmx-8003",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: null,
      code: "0x8003",
      code_type: "TwinCAT PLC Library",
      title_ar: "Communication buffer overflow",
      description_ar: "مكتبة TcDMX سجلت overflow بذاكرة الاتصال.",
      symptoms: ["0x8003", "طلبات الاتصال ما تنعالج طبيعي"],
      causes: ["حمل طلبات أعلى من تحمل الـbuffer", "تسلسل استدعاءات مو مناسب"],
      checks: [
        {
          step: 1,
          action: "راقب تكرار الاستدعاءات وحالة Busy/Done/Error.",
          expected: "الطلبات تنرسل بدون تراكم.",
          faulty: "يتكرر overflow.",
        }
      ],
      solutions: ["قلل تكرار الطلبات والتزم بحالة الـFB.", "راجع منطق queue/handshake."],
      severity: "عالية",
      source_title: "Beckhoff TwinCAT 2 PLC Library TcDMX",
      source_section: "Error codes: 0x8003 Communication buffer overflow",
      keywords: ["Beckhoff", "TwinCAT", "TcDMX", "0x8003", "buffer overflow"],
    },
    {
      id: "beckhoff-tcdmx-8006",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: null,
      code: "0x8006",
      code_type: "TwinCAT PLC Library",
      title_ar: "Checksum error",
      description_ar: "مكتبة TcDMX سجلت خطأ checksum بالاتصال.",
      symptoms: ["0x8006", "بيانات الاتصال مرفوضة"],
      causes: ["تشويش أو بيانات تالفة", "مشكلة بالاتصال أو الجهاز"],
      checks: [
        {
          step: 1,
          action: "افحص جودة الاتصال والتوصيلات.",
          expected: "ماكو checksum errors.",
          faulty: "0x8006 يتكرر.",
        }
      ],
      solutions: ["عالج التشويش والتوصيلات.", "افحص الجهاز والطرف المقابل."],
      severity: "عالية",
      source_title: "Beckhoff TwinCAT 2 PLC Library TcDMX",
      source_section: "Error codes: 0x8006 Checksum error",
      keywords: ["Beckhoff", "TwinCAT", "TcDMX", "0x8006", "checksum"],
    },  ],
};
